import { Domain } from '../domain-config/domain-config'

export const GTAG_ID = 'GTM-M9G7X6'
export const PROXY_SUBDOMAIN = process.env.PROXY_SUBDOMAIN || 'https://website.prod.'
export const WEBSITE_CREDENTIALS_USER = process.env.WEBSITE_CREDENTIALS_USER || 'production'
export const WEBSITE_CREDENTIALS_PW = process.env.WEBSITE_CREDENTIALS_PW || 'jodelet6gusuliau'
export const ASSET_SERVER_URL: string =
  process.env.ASSET_SERVER_URL || 'https://img.fitreisen.group'

export const SKIP_CACHE_WARMING: boolean = process.env.SKIP_CACHE_WARMING === 'true'
export const SKIP_AUTHENTIFICATION: boolean = process.env.SKIP_AUTHENTIFICATION === 'true'
export const FALLBACK_DOMAIN: Domain =
  (process.env.FALLBACK_DOMAIN as Domain) || Domain.FITREISEN_DE
export const CURRENCY_SEARCH_PARAMETER = 'currency'
export const DOMAIN_OVERWRITE = 'DOMAIN_OVERWRITE'
export const STANDARD_COOKIE_LIFETIME_IN_DAYS = 60
export const JUNE_ID_COOKIE_LIFETIME_IN_DAYS = 365 * 10
export const JUNE_ID_COOKIE_KEY = 'JID'

export const HEADER_NAME_FEATURE_FLAGS_PATH = 'X-FIT-FEATURE-FLAGS-PATH'
export const PUBLIC_MAPBOX_TOKEN =
  'pk.eyJ1IjoiZml0cmVpc2VuIiwiYSI6ImNqdHppeXlkMDBiazk0M3QxZDFpNGNqYmgifQ.f6VsL4UgB13NPCXv9-vJGQ'

export enum FilterModalType {
  ALL,
  PRICE,
  GUESTS,
  RATING,
  LOCATION,
  ORDER,
  ORDER_MOBILE,
  STARS,
}

export enum SearchSection {
  TopCountriesGroup = 'topCountrygroupLabel',
  CountryGroup = 'countrygroupLabel',
  TopCountries = 'topCountriesLabel',
  Country = 'countryLabel',
  TopRegions = 'topRegionsLabel',
  Region = 'regionLabel',
  TopHotels = 'topHotelsLabel',
  Hotel = 'hotelLabel',
  TopLocations = 'topLocationsLabel',
  Location = 'locationLabel',
  Topic = 'topicsLabel',
  TopTopics = 'topTopicsLabel',
}

export const WIZARD_INPUT_KEY_PRESSED = 'WIZARD_INPUT_KEY_PRESSED'
export const WIZARD_INPUT_BLUR = 'WIZARD_INPUT_BLUR'
export const MAP_DISPLAY_STATUS_CHANGED = 'MAP_DISPLAY_STATUS_CHANGED'
export const CLOSE_MAP_CLICK = 'CLOSE_MAP_CLICK'

export enum PageType {
  SEO = 'seo',
  SEM = 'sem',
}

export const PAGE_TYPES = Object.values(PageType)

export const wizardLabels = {
  destinationInputProps: {
    mobileTitle: 'destinationLabelMobile',
    label: 'destinationLabel',
    placeholderDesktop: 'destinationPlaceholderDesktop',
    placeholderMobile: 'destinationLabel',
    placeholderSearchPage: 'placeHolderSearchPageDestination',
  },
  topicInputProps: {
    mobileTitle: 'topicLabelMobile',
    label: 'topicLabel',
    placeholderMobile: 'topicLabel',
    placeholderDesktop: 'topicLabelMobile',
    placeholderSearchPage: 'placeHolderSearchPageTopic',
  },
  travelPeriodInputProps: {
    mobileTitle: 'travelPeriodPlaceholder',
    label: 'travelPeriodLabel',
    placeholderDesktop: 'travelPeriodPlaceholder',
    placeholderMobile: 'travelPeriodPlaceholder',
    placeholderSearchPage: 'placeHolderSearchPageTravelPeriod',
  },
}
export const API_URL = process.env.API_URL || 'https://api.fitreisen.de/v3/'

export enum Locale {
  DE = 'de',
  EN = 'en',
  FR = 'fr',
  ES = 'es',
  IT = 'it',
  PL = 'pl',
  SV = 'sv',
  NL = 'nl',
}

export enum Country {
  DE = 'DE',
  ES = 'ES',
  FR = 'FR',
  IT = 'IT',
  PL = 'PL',
  SE = 'SE',
  NL = 'NL',
  GB = 'GB',
  CH = 'CH',
  AT = 'AT',
  US = 'US',
  CN = 'CN',
  BE = 'BE',
}

export const LOCALES = Object.values(Locale)

export const LEGAL_INVOICE_COUNTRIES = [
  'AD',
  'AE',
  'AL',
  'AN',
  'AN',
  'AR',
  'AT',
  'AU',
  'AZ',
  'AZ',
  'BA',
  'BB',
  'BE',
  'BG',
  'BH',
  'BJ',
  'BN',
  'BR',
  'BS',
  'BT',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CD',
  'CF',
  'CG',
  'CH',
  'CI',
  'CL',
  'CM',
  'CN',
  'CO',
  'CR',
  'CU',
  'CV',
  'CY',
  'CZ',
  'DE',
  'DK',
  'DM',
  'DO',
  'DZ',
  'EC',
  'EE',
  'EG',
  'ES',
  'ES',
  'ET',
  'FI',
  'FR',
  'GB',
  'GB',
  'GB',
  'GB',
  'GB',
  'GD',
  'GH',
  'GI',
  'GM',
  'GR',
  'GT',
  'GY',
  'HK',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IN',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JM',
  'JO',
  'JP',
  'KE',
  'KH',
  'KR',
  'KW',
  'KZ',
  'LA',
  'LB',
  'LC',
  'LI',
  'LK',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'ME',
  'MG',
  'MK',
  'ML',
  'MM',
  'MM',
  'MR',
  'MT',
  'MU',
  'MV',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NE',
  'NG',
  'NI',
  'NL',
  'NO',
  'NP',
  'NZ',
  'OM',
  'PA',
  'PE',
  'PH',
  'PK',
  'PL',
  'PT',
  'PY',
  'QA',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SC',
  'SE',
  'SG',
  'SI',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'SY',
  'SZ',
  'TG',
  'TH',
  'TH',
  'TJ',
  'TN',
  'TR',
  'TT',
  'TW',
  'TZ',
  'TZ',
  'UA',
  'UG',
  'US',
  'UY',
  'VA',
  'VC',
  'VC',
  'VE',
  'VN',
  'WS',
  'XX',
  'YE',
  'ZA',
  'ZM',
  'ZW',
  'ZZ',
]

export const NUMBER_INPUT_COUNTRIES = [Domain.SPADREAMS_COM, Domain.SPADREAMS_ES]
